












import { Component, Prop, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Types
import { IBasketProviderData } from "@/models/providers/baskets";

@Component
export default class ContinueShoppingButton extends Mixins(Context) {
  // Inject - Basket provider

  @Inject({ from: "basketProviderData" })
  public readonly $basketData!: () => IBasketProviderData;

  // Props

  @Prop({ default: true })
  public isButton!: boolean;
}
